import { observer } from "mobx-react-lite";

export const HelpCenter = observer(() => {
  return <div className="flex"></div>;
});
